import a from "./_getNative.js";
import o from "./_root.js";
var t = a(o, "WeakMap");
const p = t;
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_WeakMap.js
// module id = 1413
// module chunks = 41